  
  export const escapeCSV = (value) => {
    if (value === null || value === undefined) {
      return 'N/A';
    }
  
    let stringValue = String(value);
    stringValue = stringValue.replace(/"/g, '""');
    if (stringValue.indexOf(',') > -1 || stringValue.indexOf('\n') > -1 || stringValue.indexOf('"') > -1) {
      stringValue = `"${stringValue}"`;
    }
  
    return stringValue;
  };
  
  // Function to strip HTML tags from a string.
  // Uses DOMParser then removes any remaining tag-like fragments (e.g. empty <p></p> that

  export const stripHtmlTags = (html) => {
    if (html == null || html === '') return '';
    const str = String(html);
    const doc = new DOMParser().parseFromString(str, 'text/html');
    let out = (doc.body && doc.body.textContent) ? doc.body.textContent : str;
    out = out.replace(/<[^>]*>/g, '').trim();
    return out;
  };

  // Function to convert a string to a color
  export const stringToColor = (string) => {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
  };

  // Function to get the initial of a string (Username)
  export const getInitial = (username) => {
    return username ? username.charAt(0).toUpperCase() : '?';
  };
  
  // Function to convert a snake_case string to Capitalized Words
  export const formatEnum = (username) => {
    return username
      .split('_') 
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(' '); 
  };

  // Function to get the module breadcrumb text from an array of items
  export const getBreadcrumbText = (items = []) => {
    return items.map(item => item.label).join(' / ');
  }

  // Function to check if a string is empty or contains only HTML tags
  export const isEmptyHtml = (data) => {
    const result = stripHtmlTags(data);
    const empty = result.trim() == '' ? true : false;
    return empty;
  };

